import React from 'react';
import './Analysis.css';

interface AnalysisProps {
  budgetId: string;
}

const Analysis: React.FC<AnalysisProps> = ({ budgetId }) => {
  return (
    <div className="analysis-container">
      <div className="analysis-content">
        <h2>预算分析</h2>
        <p>预算ID: {budgetId}</p>
        <p>预算分析页面开发中...</p>
      </div>
    </div>
  );
};

export default Analysis;
